<template>
  <b-nav-item @click="toggleTheme">
    <feather-icon
      size="21"
      :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
    />
  </b-nav-item>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import { BNavItem } from 'bootstrap-vue'

export default {
  components: {
    BNavItem,
  },
  setup() {
    const { skin } = useAppConfig()

    // Check for a saved theme in localStorage or default to the current skin
    const savedTheme = localStorage.getItem('theme') || skin.value
    if (savedTheme) {
      skin.value = savedTheme
    }

    const isDark = computed(() => skin.value === 'dark')

    const toggleTheme = () => {
      skin.value = isDark.value ? 'light' : 'dark'
      localStorage.setItem('theme', skin.value) // Save the theme to localStorage
    }

    return { skin, isDark, toggleTheme }
  },
}
</script>
